import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(isoWeek)

/** DevExpress uses Sunday by default; planning queries use ISO Monday-first weeks. */
export const PLANNING_WEEK_START_DAY = 1

export function getPlanningWeekRange(date: Date): { startDate: string; endDate: string } {
  return {
    startDate: dayjs(date).startOf('isoWeek').toISOString(),
    endDate: dayjs(date).endOf('isoWeek').toISOString(),
  }
}
